import { render } from "./ContentCard.vue?vue&type=template&id=f21271c8&scoped=true"
import script from "./ContentCard.vue?vue&type=script&lang=ts"
export * from "./ContentCard.vue?vue&type=script&lang=ts"

import "./ContentCard.vue?vue&type=style&index=0&id=f21271c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f21271c8"

export default script